var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHipAssisticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HIP Assist Module copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1107 25.1378C17.1063 24.0622 18.533 23.3911 20.1107 23.3911C21.6885 23.3911 23.1107 24.0622 24.1107 25.1378C24.3818 25.4267 24.6174 25.7467 24.8174 26.0889C25.813 27.1645 27.2396 27.8356 28.8174 27.8356C31.8307 27.8356 34.2752 25.3867 34.2752 22.3734C34.2752 19.36 31.8307 16.9111 28.8174 16.9111C27.2352 16.9111 25.813 17.5822 24.8174 18.6578C24.6174 19 24.3774 19.32 24.1107 19.6089C23.1152 20.6845 21.693 21.3556 20.1107 21.3556C18.5285 21.3556 17.1063 20.6845 16.1107 19.6089C15.8396 19.32 15.6041 19 15.4041 18.6578C14.4085 17.5822 12.9818 16.9111 11.4041 16.9111C8.39073 16.9111 5.94629 19.3556 5.94629 22.3734C5.94629 25.3911 8.39073 27.8356 11.4041 27.8356C12.9863 27.8356 14.4085 27.1645 15.4041 26.0889C15.6041 25.7467 15.8441 25.4267 16.1107 25.1378Z",
    fill: "#A399B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0933 13.0845C24.0933 15.1867 22.391 16.8934 20.2888 16.8934C18.1866 16.8934 16.4844 15.1867 16.4844 13.0845C16.4844 10.9823 18.1866 9.27563 20.2888 9.27563C22.391 9.27563 24.0933 10.9823 24.0933 13.0845Z",
    fill: "#A399B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0933 22.4178C24.0933 24.52 22.391 26.2267 20.2888 26.2267C18.1866 26.2267 16.4844 24.52 16.4844 22.4178C16.4844 20.3156 18.1866 18.6089 20.2888 18.6089C22.391 18.6089 24.0933 20.3156 24.0933 22.4178Z",
    fill: "#A399B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipAssisticon);
export default __webpack_public_path__ + "static/media/HIP Assist icon.f322b973745e272e45b78fcf84b0ee10.svg";
export { ForwardRef as ReactComponent };